import { render } from "./accountInformation.vue?vue&type=template&id=4862dad1&scoped=true&ts=true"
import script from "./accountInformation.vue?vue&type=script&lang=ts"
export * from "./accountInformation.vue?vue&type=script&lang=ts"

import "./accountInformation.vue?vue&type=style&index=0&id=4862dad1&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4862dad1"]])

export default __exports__